import {Component, OnInit, Input} from '@angular/core';
import {RilrService} from "../services/rilr.service";
import {DomSanitizer} from '@angular/platform-browser';

@Component({
    selector: 'app-report-approval-details',
    templateUrl: './report-approval-details.component.html',
    styleUrls: ['./report-approval-details.component.scss'],
    providers: [RilrService]
})
export class ReportApprovalDetailsComponent implements OnInit {

    approvalUsersTbl: any = [];
    @Input('documentSystemID') documentSystemID: any;
    @Input('reportSystemID') reportSystemID: any;
    @Input('companySystemID') companySystemID: any;

    constructor(private rilrService: RilrService,
                private sanitizer: DomSanitizer) {
    }

    ngOnInit() {
        setTimeout(() => {
            this.getAllApprovals();
        }, 0);
    }

    getAllApprovals() {
        const that = this;
        that.approvalUsersTbl = [];
        that.rilrService
            .getAllApprovalsRecords()
            .get({
                'reportSystemID': that.reportSystemID,
                'documentSystemID': that.documentSystemID
            })
            .subscribe(resp => {
                that.approvalUsersTbl = resp.data.data;
            }, (error) => {
            });
    }

}



// WEBPACK FOOTER //
// /app/src/app/report-approval-details/report-approval-details.component.ts